import { render, staticRenderFns } from "./wine-investors-registration2.vue?vue&type=template&id=a294bb16&scoped=true"
import script from "./wine-investors-registration2.vue?vue&type=script&lang=js"
export * from "./wine-investors-registration2.vue?vue&type=script&lang=js"
import style0 from "./wine-investors-registration2.vue?vue&type=style&index=0&id=a294bb16&prod&scoped=true&lang=css"
import style1 from "./wine-investors-registration2.vue?vue&type=style&index=1&id=a294bb16&prod&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a294bb16",
  null
  
)

export default component.exports